/*
 * CongregationForm Messages
 *
 * This contains all the text for the CongregationForm component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    id: 'app.components.CongregationForm.name',
    defaultMessage: 'Name',
  },
  circuit: {
    id: 'app.components.CongregationForm.circuit',
    defaultMessage: 'Circuit',
  },
  watchtowerId: {
    id: 'app.components.CongregationForm.watchtowerId',
    defaultMessage: 'Watchtower Id',
  },
  tourNumber: {
    id: 'app.components.CongregationForm.tourNumber',
    defaultMessage: 'Tour Number',
  },
  required: {
    id: 'app.components.CongregationForm.required',
    defaultMessage: 'This field is required',
  },
});
